import ToastMessages from "constants/ToastMessages";

interface SdeappsApiResponse<T> {
  data: T;
}

export async function apiFetch<T>(url: string, options: RequestInit): Promise<T> {
  const response = await fetch(url, options);
  const json = await response.json();
  if (response.ok) {
    const body = json as SdeappsApiResponse<T>;
    return body?.data;
  } else {
    const errorMessage: string = json?.description ?? ToastMessages.ERROR;
    throw new Error(errorMessage);
  }
}
